import { render, staticRenderFns } from "./CartItemView.vue?vue&type=template&id=376c4ace&scoped=true&"
import script from "./CartItemView.vue?vue&type=script&lang=js&"
export * from "./CartItemView.vue?vue&type=script&lang=js&"
import style0 from "./CartItemView.vue?vue&type=style&index=0&id=376c4ace&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "376c4ace",
  null
  
)

export default component.exports